import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const fetchCommunicationStreamData = (externalEquipmentReference: string, startTime: string, endTime: string, messageType: string, paginationToken: string, rtcType: string): AxiosPromise<CommunicationDataMessageType> => csttFacadeApi.get(`/csttfacade/communicationdata/v2/equipment/${externalEquipmentReference}/sources/streamdata?startTime=${startTime}&endTime=${endTime}&messageType=${messageType}&paginationToken=${paginationToken}&rtcModel=${rtcType}`);
const sendExportCommunicationHistoryViaBackend = (externalEquipmentReference: string, requestBody: any): AxiosPromise<CommunicationDataMessageType> =>
    csttFacadeApi.post(`/csttfacade/communicationdata/v1/equipment/${externalEquipmentReference}/export`, requestBody)

export {
    fetchCommunicationStreamData,
    sendExportCommunicationHistoryViaBackend
};